<template>
  <div>
    <link href="../../static/distribution-musical/css/plugins.css" rel="stylesheet" type="text/css" media="all">
    <link href="../../static/distribution-musical/css/theme.css" rel="stylesheet" type="text/css" media="all">
    <link href="../../static/distribution-musical/css/custom.css" rel="stylesheet" type="text/css" media="all">
    <link href='https://fonts.googleapis.com/css?family=Open+Sans:400,300%7CMontserrat:400,700%7CRaleway:400,200,300' rel='stylesheet' type='text/css'>
    <!-- Hero Slider -->
    <section class="hero-fullscreen" style="height:100vh;">
        <div class="hero-slider hero-parallax-fullscreen owl-carousel navigation-thin">
          <!-- Slide 1 -->
          <div class="slide bg-attraction">
            <div class="hero-container container">
              <div class="hero-content scroll-opacity">
                <div class="appear container text-center">
                  <a class="logo-dark" href="/">
                    <img src="https://indiefy.net/static/img/logo_white_new.png" alt="logo-indiefy" style="max-width:230px">
                  </a>
                  <p class="subheading white mt40" v-if="lang === 'es'">Distribucion musical para todos</p>
                  <p class="subheading white mt40" v-else>MUSIC DISTRIBUTION FOR EVERYONE</p>
                  <h1 class="lg-heading white mb40">AI<br>Mastering</h1>
                  <p class="white hidden-xs attrac-description">
                    {{ $t('mastering_title_description') }}
                  </p>
                  <router-link to="/login?next=tools/mastering" class="btn btn-ghost-pink btn-scroll mt60 btn-more">{{ $t('start_now') }}</router-link>
                </div>
              </div>
            </div>
          </div>
          <!-- End Slide 1 -->
        </div>
    </section>
  </div>
</template>
<script>
import Blog from '../services/blog'
export default {
  name: 'ProLayout',
  lang: 'en',
  data () {
    return {
      year: new Date().getFullYear(),
      totalDistros: 61735,
      totalUsers: 149154
    }
  },
  methods: {

  },
  created: function () {
    if (this.$route.path.match('/distribucion-musical-gratis')) {
      this.lang = 'es'
    } else if (this.$route.path.match('/free-online-music-distribution')) {
      this.lang = 'en'
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    Blog.getPublicInfo().then(response => {
      if (response.data && !isNaN(response.data.total_distros) && !isNaN(response.data.total_users)) {
        this.totalDistros = response.data.total_distros
        this.totalUsers = response.data.total_users
      }
    })
  },
  mounted: function () {
    window.$('.hero-slider').owlCarousel({
      autoPlay: false,
      navigation: true,
      navigationText: [
        '<img src="../../static/distribution-musical/img/slider-left-thin-arrow.png">',
        '<img src="../../static/distribution-musical/img/slider-right-thin-arrow.png">'
      ],
      slideSpeed: 300,
      paginationSpeed: 400,
      singleItem: true,
      items: 1,
      autoHeight: true,
      addClassActive: true,
      beforeMove: function () {
        // BEFORE going to the next slide (hide captions)
      },
      afterMove: function () {
        // AFTER going to next slide (show captions)
      }
    })
    setTimeout(() => {
      window.$('#owl-testimonials').owlCarousel({
        autoPlay: false,
        singleItem: true,
        pagination: true,
        navigation: false,
        items: 1
      })

      setTimeout(() => {
        window.prerenderReady = true
      })
    }, 100)
  }
}
</script>
<style scoped>
.pro-description {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/MasteringPublic.vue